import { Col, Container, Row } from "react-bootstrap";
import Button from "../button";
import { rightArrow } from "../images/svg/icons";
import { bookkeepingImage } from "../images/png/icons";
import { useTranslation } from "react-i18next";

export const BookKeepingSection = ({ navigateToRoute }: { navigateToRoute: (swedishPath: string, EnglishPath: string) => void }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Row className="padding-116 d-flex justify-content-end row-gap">
        <Col xs={12} lg={12} xl={6} className="px-0">
          <div className="py-custom-xl d-flex flex-column h-100">
            <h1 className="Heading_h1 w-100 pr-0 pr-xl-5 mb-0">{t("START_YOUR_BUSINESS_TITLE")}</h1>
            <p className="mb-0 py-4 pr-0 pr-sm-5 pr-xl-5">{t("START_YOUR_BUSINESS_DESC")}</p>

            <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center mt-2">
              <Button
                variant="primary"
                size="sm"
                className="d-flex align-items-center justify-content-center gap-2 fs-6 mobile-w-50"
                onClick={() => navigateToRoute("contact-us", "kontakta-oss")}
              >
                {t("CONTACT_US")}
                <img src={rightArrow} alt="" className="ms-1 mb-1" />
              </Button>
            </div>
          </div>
        </Col>

        <Col xs={12} lg={12} xl={6} className="d-flex justify-content-start  justify-content-md-start justify-content-md-start justify-content-xl-end pt-4 pt-xl-0 px-0">
          <img
            src={bookkeepingImage}
            alt={t("FINANCIAL_SERVICES_ALT")}
            loading="lazy"
            className="img-fluid"
          />
        </Col>
      </Row>
    </Container>
  );
};
